import iamAPI from "../../api/iamAPI";
import { urlContexts } from "../../constants";

const token = () => {
  return sessionStorage.getItem('REDIRECT::INFO') ?? new URLSearchParams(window.location.search).get('token') ?? '';
};

export const getUsers = async (tenantId: string) => {
  const { data } = await iamAPI.get(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/user?tenantId=${tenantId}`,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};

export const createUsers = async (createUser: any) => {
  const { data } = await iamAPI.post(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/user`,
    createUser,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};

export const updateUsers = async (updateUser: any) => {
  const { data } = await iamAPI.put(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/user?userId=${updateUser.id}`,
    updateUser,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};

export const deleteUsers = async (deleteUser: string) => {
  const { data } = await iamAPI.delete(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/user/${deleteUser}`,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};

export const sendTempPassword = async (user: any) => {
  const { data } = await iamAPI.post(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/user/reset-password`,
    { id: user.id },
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};

export const resetOtp = async (user: any) => {
  const { data } = await iamAPI.post(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/user/reset-otp`,
    { id: user.id },
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};